import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {
    renderTextInputField,
    renderEmailInputField
} from '../Layout/FormInputs'
import {langs} from '../../config/localization';
import FileInput from "../Common/FileInput";
import {setSignupData} from "../../actions/Auth/AuthActions";
import {required, maxLength30, maxLength100} from '../../validation';
import {defaultImage} from '../../actions/Common';
import ImageCompressor from 'image-compressor.js';
import {focusOnError} from "../../utils";
import {toastr} from "react-redux-toastr";
import { registerUser } from "../../actions/Auth/AuthActions";
import {Loader} from "../Common/Loader";

let imageURL = '';
class Signup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showLoader: false,
            profilePic: '/assets/images/eathdeck/camera.png'
        };
    }

    /**
     * On change profile image
     * @param image
     */
    onChangeProfileImage(image) {
        let fileType = image.type;
        if(fileType.includes('jpg') || fileType.includes('jpeg') || fileType.includes('png')){
            const reader  = new FileReader();
            /*reader.readAsDataURL(image);
            reader.onload = function (fileLoadedEvent) {
                imageURL = fileLoadedEvent.target.result;
                this.setState({
                     profilePic : imageURL
                 });
             }.bind(this);*/

            new ImageCompressor(image, {
                quality: .8,
                width: 150,
                height:150,
                success(result) {

                    reader.readAsDataURL(result);
                    //reader.readAsDataURL(image);
                    reader.onload = function (fileLoadedEvent) {
                        imageURL = fileLoadedEvent.target.result;
                    };
                },
                error(e) {

                },
            });

            var INTERVAL = setInterval(function(){
                if(imageURL != ''){
                    clearInterval(INTERVAL);
                    this.setState({profilePic: imageURL});
                }
            }.bind(this), 100);
        }else{
            this.setState({
                invalidProfilePic : true
            });
        }
    }

    /**
     * Set signup data
     * @param values
     */
    onSubmit(values){
        const inputs = {...values, profilePic: imageURL};
        values.name = String.prototype.trim.call(values.name);
        values.email = String.prototype.trim.call(values.email);

        //Call the set signup data action
        // this.props.setSignupData(inputs, () => {
        //     toastr.success(langs.success, langs.messages.one_step_behind_signup);
        //     this.props.history.push(`/profile-questions`);
        // });

        // hard coded profile page values
        inputs.profile = {
            "yourStories":{
                "nameWebsites":[]
            },
            "contentLike":[],
            "socialNetworks":{
                "selectedOptions":[],
                "other":""
            }
        };

        this.setState({ showLoader: true });

        this.props.registerUser(inputs, (response) => {
            this.setState({ showLoader: false });

            if(response.status === 201) {

                toastr.success(langs.success, langs.messages.registration_success);
                //Delay the page redirection for 3 second to show toastr message
                // let video_detail = getVideoDetailLocalStorage();
                /* As here auth token is not generated so need to remove Auth token from the API
                That's why comment code here for now. */
                // this.props.saveVideoClickData(video_detail, (response)=>{
                //     console.log("video detail Saved", response);
                // });
                setTimeout(function () {
                    window.location.assign('/signup-success');
                }.bind(this), 10);
            } else if(response.status === 409) {//If email already exist

                toastr.error(langs.error, response.data.error.message);
                //Delay the page redirection for 3 second to show toastr message
                // setTimeout(function () {
                //     window.location.assign('/signup');
                // }.bind(this), 3000);
            }else{

                toastr.error(langs.error, langs.messages.default_error);
                //Delay the page redirection for 3 second to show toastr message
                // setTimeout(function () {
                //     window.location.assign('/signup');
                // }.bind(this), 3000);
            }
        });
    }

    /**
     * Render the login form
     * @returns {*}
     */
    render(){
        const {handleSubmit} = this.props;
        const {profilePic, showLoader} = this.state;

        return (
            <section className="section-login">
                {
                    showLoader && (
                        <Loader loaderContent='form-submission' />
                    )
                }
                <div className="row">
                    <div className="medium-12 columns">
                        <div className="login-wrapper">
                            <div className="login-container">
                                <div className="login-left primary-gradient-bg">
                                    <div className="globe-bg signup-page">
                                        <h2>Welcome to earthDECKS, <span>Sign Up</span> to continue</h2>
                                    </div>
                                    <div className="map-bg">
                                        <img src="assets/images/eathdeck/map.png" />
                                    </div>
                                </div>
                                <div className="login-right">
                                    <h1>Sign Up</h1>
                                    <form noValidate className="form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        <div className="icon-form camera-icon text-center">
                                            <div className="upload-btn-wrapper">
                                                <button type="button" className="btn" style={{backgroundImage:`url(${profilePic})`}}></button>
                                                <input type="file" name="myfile"/>
                                                <Field
                                                    name="profilePic"
                                                    component={FileInput}
                                                    onChangeProfileImage={this.onChangeProfileImage.bind(this)}
                                                />
                                            </div>
                                        </div>
                                        <div className="login-form">
                                            <div className="form-group clearfix">
                                                <label>Name*</label>
                                                <Field
                                                    name="name"
                                                    component={renderTextInputField}
                                                    validate={[maxLength30]}
                                                    maxLength="30"
                                                    onChange={this.handleNameChange}
                                                />
                                            </div>
                                            <div className="form-group clearfix">
                                                <label>Email*</label>
                                                <Field
                                                    name="email"
                                                    validate={[maxLength100]}
                                                    maxLength="100"
                                                    component={renderEmailInputField}
                                                />
                                            </div>
                                            <div className="form-group clearfix">
                                                <label>Where do you live? (City, State or Province, Country)*</label>
                                                <Field
                                                    name="location"
                                                    validate={[maxLength100]}
                                                    maxLength="100"
                                                    component={renderTextInputField}
                                                />
                                            </div>
                                            <div className="form-group text-center">
                                                <button type="submit" className="btn-primary primary-gradient-bg">
                                                    <span>SIGN UP</span>
                                                </button>
                                            </div>
                                            <div className="form-group no-account text-center">
                                                <p>Already have an account? <a href="/login" className="">Login</a></p>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};

    if(!values.name){
        errors.name = langs.validation_messages.fullname_required;
    }

    if (values.name && values.name.length > 30){
        errors.name = langs.validation_messages.fullname_pattern;
    }

    if(!values.email){
        errors.email = langs.validation_messages.email_required;
    }

    if(values.email && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email) == false){
        errors.email = langs.validation_messages.email_pattern;
    }

    if(!values.location){
        errors.location = langs.validation_messages.location_required;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: 'Signup',
    onSubmitFail: (errors) => {
        focusOnError(errors)
    }
})(
    connect(null, {setSignupData, defaultImage, registerUser})(Signup)
);



// WEBPACK FOOTER //
// ./components/Auth/Signup.js